import { z } from 'zod';

export enum OrganizationUserRole {
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  MEMBER = 'MEMBER',
  // NOTE(mike): This is a test-only role to check that our permissions system
  // doesn't allow users to do things they shouldn't be able to do.
  TEST_ONLY_READ_ONLY = 'TEST_ONLY_READ_ONLY',
}

export const OrganizationUserRoleSchema = z.nativeEnum(OrganizationUserRole);
